export const getLeafNodes = (graph) => {
    // Filter nodes that have an empty adjacency list (no outgoing links)
    const leafNodes = Object.keys(graph).filter((node) => graph[node].length === 0);
    return leafNodes;
};
